import React, { createContext, useState, useEffect } from 'react';

// Firebase
import { useFirebaseApp } from 'reactfire';
import { db } from '../utils/firebaseConfig';

interface CurrentUserProps {
    email: string,
    uid: string
}

interface AuthContextData {
    isAdmin: boolean,
    isLogged: boolean,
    currentUser: CurrentUserProps | null,
    emailVerified: boolean,
}
const AuthContext = createContext<AuthContextData>({} as AuthContextData);

// Exportando AuthProvider para se rusado no routes
export const AuthProvider: React.FC = ({ children }: any) => {
    let firebase = useFirebaseApp();

    const [isAdmin, setIsAdmin] = useState(true);
    const [isLogged, setIsLogged] = useState(true);
    const [emailVerified, setEmailVerified] = useState(false);
    const [currentUser, setCurrentUser] = useState<CurrentUserProps | null>(null);

    useEffect(() => {
        getCurrentUser();
    }, []);

    const getCurrentUser = () => {
        firebase.auth().onAuthStateChanged((user: any) => {
            // Caso usuário estiver autenticado, recupera o usuário atual
            if (user) {
                let getUser: CurrentUserProps = {
                    email: user.email,
                    uid: user.uid
                }
                setCurrentUser(getUser);

                // Se o email do usuário atual estiver verificado
                if (user.emailVerified) {
                    setIsLogged(true);
                    setEmailVerified(true);
                    localStorage.setItem('_tok_user', user.refreshToken);
                    verifyUserFunction(user);
                }
                else {
                    userNotAuthenticated();
                }
            }
            else {
                userNotAuthenticated();
            }
        })
    }

    const userNotAuthenticated = () => {
        setIsAdmin(false);
        setIsLogged(false);
        setEmailVerified(false);
        localStorage.removeItem('_tok_user');
    }

    // Função para verificar se o usuário logado é admin
    const verifyUserFunction = (user: any) => {
        // Procura no firestore o id do usuário
        db.collection('Usuarios').doc(user.uid).get()
            .then(resp => {
                // Verificação se o usuário é admin
                setIsAdmin(resp.data()?.isAdmin ? true : false);

                // Caso o email não esteja verificado no firestore, atualiza (apenas para mostrar aos admins)
                if(!resp.data()?.emailVerified){
                    db.collection('Usuarios').doc(user.uid).update({
                        emailVerified: true,
                    })
                    .catch(err => {
                        console.log('Houve um erro ao atualizar a propriedade emailVerified de um usuário no firestore.')
                    })
                }
            })
    }

    return (
        <AuthContext.Provider value={{ isAdmin: isAdmin, isLogged: isLogged, currentUser: currentUser, emailVerified: emailVerified }}>
            {children}
        </AuthContext.Provider>
    );
}

export default AuthContext;
